import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=c94a6f12&scoped=true&"
import script from "./StatusLabel.vue?vue&type=script&lang=js&"
export * from "./StatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94a6f12",
  null
  
)

export default component.exports